import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { httpOptions } from 'src/app/global/global_variables';
import { ETransportQueryParameters, ETransportResponseDTO } from 'src/app/models/ETransportModel';
import { FISCOModel } from 'src/app/models/FISCOModel';
import { PackingPlanningCreateModel, PackingPlanningModel, PackingPlanningUpdateModel, } from 'src/app/models/PackingPlanningModel';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PackingPlanningService {

  apiLink = environment.apiLink

  constructor(private http: HttpClient) { }

  getAllTrips(): Observable<PackingPlanningModel[]> {
    return this.http.get<{ packingTimeTable: PackingPlanningModel[] }>(`${this.apiLink}/Emb/TimeTable`, httpOptions)
      .pipe(
        map(response => response.packingTimeTable)
      );
  }
  
  getTripsByCode(code : string): Observable<PackingPlanningModel[]> {
    return this.http.get<{ packingTimeTable: PackingPlanningModel[] }>(`${this.apiLink}/Emb/TimeTable/Code/${code}`, httpOptions)
      .pipe(
        map(response => response.packingTimeTable)
      );
  }
  
  getTripsByCodeView(code : string): Observable<PackingPlanningModel[]> {
    return this.http.get<{ packingTimeTable: PackingPlanningModel[] }>(`${this.apiLink}/View/Emb/TimeTable/Code/${code}`, httpOptions)
      .pipe(
        map(response => response.packingTimeTable)
      );
  }

  getTripsByClassification(classification : string): Observable<PackingPlanningModel[]> {
    return this.http.get<{ packingTimeTable: PackingPlanningModel[] }>(`${this.apiLink}/Emb/TimeTable/${classification}`, httpOptions)
      .pipe(
        map(response => response.packingTimeTable)
      );
  }

  getAllTripsObs(): Observable<PackingPlanningModel[]> {
    return this.http.get<{ packingTimeTable: PackingPlanningModel[] }>(`${this.apiLink}/Emb/TimeTable`, httpOptions)
      .pipe(
        map(response => response.packingTimeTable)
      );
  }

  createPlanningTrip(request: PackingPlanningCreateModel) {
    return this.http.post(`${this.apiLink}/Emb/TimeTable`, request, httpOptions)
  }

  updatePlanningTrip(request: PackingPlanningUpdateModel, id: number) {
    return this.http.put(`${this.apiLink}/Emb/TimeTable/${id}`, request, httpOptions)
  }

  deletePlanningTrip(tripId: number): Observable<any> {
    return this.http.delete(`${environment.apiLink}/Emb/TimeTable/${tripId}`, httpOptions);
  }

  getFiscoData(company: number, startTime: string, endTime: string): Observable<FISCOModel[]> {
    return this.http.get<{ content: FISCOModel[] }>(`${this.apiLink}/Trucks/FISCO?PRU=${company}&startTimestamp=${startTime}&endTimestamp=${endTime}`)
      .pipe(
        map(response => response.content)
      )
  }

  getEtransportData(request: ETransportQueryParameters): Observable<ETransportResponseDTO[]> {
    return this.http.post<ETransportResponseDTO[]>(`${this.apiLink}/Trucks/Etransport`, request, httpOptions)
  }
  
  getEtransportDataView(request: ETransportQueryParameters): Observable<ETransportResponseDTO[]> {
    return this.http.post<ETransportResponseDTO[]>(`${this.apiLink}/View/Trucks/Etransport`, request, httpOptions)
  }
}
